import i18n from '../../../../../i18n'
import { Language } from '../../../../../model/enums/enums'

export const nativeLanguage = [
    { value: Language.German, label: i18n.t<string>('language.german') },
    { value: Language.English, label: i18n.t<string>('language.english') },
    { value: Language.French, label: i18n.t<string>('language.french') },
    { value: Language.Italian, label: i18n.t<string>('language.italian') },
    { value: Language.Spanish, label: i18n.t<string>('language.spanish') },
    { value: Language.Polish, label: i18n.t<string>('language.polish') },
    { value: Language.Russian, label: i18n.t<string>('language.russian') },
    { value: Language.Hindi, label: i18n.t<string>('language.hindi') },
    { value: Language.Bengali, label: i18n.t<string>('language.bengali') },
    { value: Language.Mandarin, label: i18n.t<string>('language.mandarin') },
    { value: Language.Japanese, label: i18n.t<string>('language.japanese') },
    { value: Language.Arabic, label: i18n.t<string>('language.arabic') },
    { value: Language.Portuguese, label: i18n.t<string>('language.portuguese') },
    { value: Language.Turkish, label: i18n.t<string>('language.turkish') },
    { value: Language.Ukrainian, label: i18n.t<string>('language.ukrainian') },
    { value: Language.Dutch, label: i18n.t<string>('language.dutch') },
    { value: null, label: i18n.t<string>('core.statistic.not_specified') }
]
